export default "__VITE_ASSET__DOYlW1oZ__"